import { IChangeTLSubscriptionPricingTierModel } from '../../../../models/interfaces/Subscription/TravelLicense/ChangeTLSubscriptionPricingTierModel';

export const TLSubscriptionDefaultValue: IChangeTLSubscriptionPricingTierModel =
  { seatsAmount: 1, price: 0 };
export const TLSubscriptionDefaultValueArray = [TLSubscriptionDefaultValue];
